module.exports = __webpack_public_path__ + "static/media/WorkerServicing.8be90e0a.png";